import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import BadgeQuestion from 'entity/BadgeQuestion';
import QuestionInputType from 'enums/QuestionInputType';

import { ConditionInterface, OperatorsInterface } from '../entry-flow-group-former.component';

@Component({
  selector: 'group-former-option',
  templateUrl: './group-former-option.component.html',
  styleUrls: ['./group-former-option.component.scss'],
  standalone: false,
})
export class GroupFormerOptionComponent extends Loggable implements OnDestroy, OnInit {
  private destroyed$ = new ReplaySubject<boolean>(1);

  @Input() public conditionIndex?: number;
  @Input() public condition?: ConditionInterface;
  @Input() public questions: BadgeQuestion[] = [];
  @Input() public operators?: OperatorsInterface[];

  @Output() public transitionOperatorChange = new EventEmitter<string>();
  @Output() public emitDeleteCondition = new EventEmitter<number>();

  public operatorList: string[] = [];

  public selectedQuestion?: BadgeQuestion;
  public selectedOperator? = '';
  public selectedTransitionOperator = 'and';

  public constructor() {
    super();
    this.setDisplayName('GroupFormerOptionComponent');
  }

  public ngOnInit(): void {
    this.info('init');
    this.selectedQuestion = this.questions.find((question) => question.title === this.condition?.property);
    this.operatorList = this.operators?.map((item) => item.operator) || [];
    this.selectedOperator = this.condition?.operator?.operator;
  }

  public selectProperty() {
    if (this.condition) {
      this.condition.property = this.selectedQuestion?.title;
    }
  }

  public selectOperator() {
    if (this.condition) {
      this.condition.operator = this.operators?.find((item) => item.operator === this.selectedOperator);
      if (this.condition.operator && !this.condition.operator.hasValue) {
        this.condition.value = undefined;
      }
    }
  }

  // Check question type
  public questionTypeInput(type?: QuestionInputType): boolean {
    return type === QuestionInputType.TEXT || type === QuestionInputType.PARAGRAPH;
  }

  public questionTypeNumber(type?: QuestionInputType): boolean {
    return type === QuestionInputType.NUMBER;
  }

  public questionTypeSingleSelect(type?: QuestionInputType): boolean {
    return type === QuestionInputType.SINGLE_SELECT || type === QuestionInputType.MULTI_SELECT;
  }

  public transitionChange() {
    if (this.selectedTransitionOperator === 'or') {
      this.transitionOperatorChange.emit('or');
    }
  }

  public deleteCondition() {
    this.emitDeleteCondition.emit(this.conditionIndex);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
